// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".export-progress-box[data-v-30707f20]{text-align:center;padding:20px}.export-progress-title[data-v-30707f20]{font-size:16px;margin-bottom:16px}.export-progress-tip[data-v-30707f20]{color:#909399;margin-top:12px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
